import axios from "axios";

const axiosInstance = axios.create({
  // baseURL: `https://147.79.71.119:5000/`,
  baseURL: `https://api.playjeeto.in:5000/`,
  // baseURL: `https://127.0.0.1:5000/`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getMovieDetailsFromAI = async (searchQuery) => {
  try {
    const response = await axiosInstance.post("/searchmovieai", {
      query: searchQuery,
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getMovieDetails = async (movieName, movieYear) => {
  try {
    const response = await axiosInstance.post("/searchmovieoutsource", {
      name: movieName,
      year: movieYear,
    });
    const parsedData = {
      title: response.data.Title,
      year: response.data.Year,
      rated: response.data.Rated,
      released: response.data.Released,
      runtime: response.data.Runtime,
      genre: response.data.Genre,
      director: response.data.Director,
      writer: response.data.Writer,
      actors: response.data.Actors,
      plot: response.data.Plot,
      language: response.data.Language,
      country: response.data.Country,
      awards: response.data.Awards,
      poster: response.data.Poster,
      metascore: response.data.Metascore,
      imdb_rating: response.data.imdbRating,
      imdb_id: response.data.imdbID,
      box_office: response.data.BoxOffice,
    }
    return parsedData;
  } catch (error) {
    return null;
  }
};

export const checkServerConnection = async () => {
  try {
    const response = await axiosInstance.get("/");
    return response.status;
  } catch (error) {
    return null;
  }
};

export const updateMovieDetails = async (Title, Year, Rated, Released, Runtime, Genre, Director, Writer, Actors, Plot, Language, Country, Awards, Poster, Metascore, imdbRating, imdbID, BoxOffice) => {
  const parsedData = { title: Title, year: Year, rated: Rated, released: Released, runtime: Runtime, genre: Genre, director: Director, writer: Writer, actor: Actors, plot: Plot, language: Language, country: Country, awards: Awards, poster: Poster, metascore: Metascore, imdbrating: imdbRating, imdbid: imdbID, boxoffice: BoxOffice }
  try {
    const response = await axiosInstance.post('/addamovie', parsedData);
    return response.data;
  } catch (err) {
    return null;
  }
}

export const searchMovieInHouse = async (movieName, movieYear) => {
  try {
    const response = await axiosInstance.post('/searchmovieinhouse', { name: movieName, year: movieYear })
    if (response) {
      const parsedData = {
        title: response.data.title,
        year: response.data.year,
        rated: response.data.rated,
        released: response.data.released,
        runtime: response.data.runtime,
        genre: response.data.genre,
        director: response.data.director,
        writer: response.data.writer,
        actors: response.data.actor,
        plot: response.data.plot,
        language: response.data.language,
        country: response.data.country,
        awards: response.data.awards,
        poster: response.data.poster,
        metascore: response.data.metascore,
        imdb_rating: response.data.imdb_rating,
        imdb_id: response.data.imdb_id,
        box_office: response.data.box_office,
      }
      return parsedData;
    }
  } catch (err) {
    return null
  }
}

export const getFavMovie = async (userID) => {
  try {
    const response = await axiosInstance.post('/getfavouritemovie', { userID: userID })
    if (response) {
      return response.data;
    }
  } catch (err) {
    return null;
  }
}

export const setFavMovie = async (imdbID, userID) => {
  try {
    const response = await axiosInstance.post('/setfavouritemovie', { movieID: imdbID, userID: userID })
    if (response) {
      return response.data;
    }
  } catch (err) {
    return null;
  }
}

export const checkLogin = async (username, password) => {
  try {
    const response = await axiosInstance.post('/login', { username: username, password: password });
    if (response) {
      return response.data.details;
    }
  } catch (error) {
    return null;
  }
}
